import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getFormData } from "../../../common/FormUtil";
import { deleteLivingArea, updateLivingArea } from "../../../repository/RealEstateRepository";
import { RealEstateMap } from "./RealEstateMap";

const LivingAreaDetail = (props) => {
  const { detail, livingAreaList, nearLivingAreaList } = props;
  const [overlay, setOverlay] = useState({});

  // overlay initialize
  useEffect(() => {
    setOverlay({ id: -1, boundary: detail.boundary });
  }, [detail.boundary]);

  const onSubmit = (e) => {
    e.preventDefault();
    const formData = getFormData(e.target);
    const request = { ...formData, boundary: overlay.boundary };
    updateLivingArea(request, () => {
      props.reload(detail.id);
      overlay && overlay.origin && overlay.origin.setMap(null);
    });
  };

  const onClickDelete = (e) => {
    e.preventDefault();
    const answer = window.confirm("Are you sure?");
    if (answer) {
      deleteLivingArea({ id: detail.id }, () => {
        props.history.push(`/realestate/livingarea`);
      });
    }
  };

  const detailPolygon = {
    name: detail.name,
    boundary: detail.boundary,
    option: {
      strokeOpacity: 0.2,
      fillOpacity: 0.1
    }
  };

  const otherPolygons = nearLivingAreaList.filter(v => v.id !== detail.id)
    .map(v => ({
      name: v.name,
      boundary: v.boundary ? v.boundary.map(c => ({ x: c[0], y: c[1] })) : [],
      option: {
        strokeOpacity: 0.2,
        fillOpacity: 0.1,
        fillColor: (detail.frontYardId === v.frontYardId) ? "orange" : "green",
        strokeColor: (detail.frontYardId === v.frontYardId) ? "orange" : "green"
      }
    }));

  let polygons = [detailPolygon];
  polygons = polygons.concat(otherPolygons);

  return (<>
    <form onSubmit={onSubmit}>
      <div className="row form-group text-left">
        <div className="col-3 col-md-2">
          <label className="col-form-label">FrontYard</label>
        </div>
        <div className="col-9 col-md-10">
          <input className="form-control" value={detail.frontYardName} readOnly={true} />
        </div>
      </div>

      <div className="row form-group text-left">
        <div className="col-3 col-md-2">
          <label className="col-form-label">LivingArea</label>
        </div>
        <div className="col">
          <input name="id" type="hidden" value={detail.id} readOnly={true} />
          <input name="name" className="form-control" defaultValue={detail.name} />
        </div>
        <div className="col">
          <input name="weight" className="form-control" value={detail.weight} readOnly={true} />
        </div>
      </div>

      <div className="row form-group text-left">
        <div className="col-3 col-md-2">
          <label className="col-form-label">Others</label>
        </div>
        <div className="col-9 col-md-10">
          <LivingAreaListV2 detail={detail} items={livingAreaList} />
        </div>
      </div>

      <div className="row form-group">
        <RealEstateMap
          height={560}
          useDrawingManager={true}
          polygons={polygons}
          onInit={(map) => {
            map.moveTo(detail.center);
            props.onChangeMapBounds(map);
          }}
          onIdle={props.onChangeMapBounds}
          onCreateOverlay={(o) => setOverlay(o)} />
      </div>

      <div className="row">
        <div className="col-12 form-group">
          <button className="btn btn-danger" onClick={onClickDelete}>Remove</button>
          &nbsp;<button type="submit" className="btn btn-primary">Update</button>
        </div>
      </div>
    </form>
  </>);
};

const LivingAreaListV2 = (props) => {
  const { detail, items } = props;
  return (<>
    {items.map(item => (
      <Link to={`/realestate/livingarea/${item.id}`}
        key={item.id}
        role="button"
        className={`btn ${detail.id === item.id ? "col-form-label" : "btn-outline-secondary"}`}
        style={{ marginBottom: 4, marginRight: 4, width: "initial" }}>
        {item.name}({item.weight})
      </Link>
    ))}
  </>)
};

export { LivingAreaDetail };
